import { render, staticRenderFns } from "./RemoteFolderConfigurationForm.vue?vue&type=template&id=743448d8&"
import script from "./RemoteFolderConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('743448d8')) {
      api.createRecord('743448d8', component.options)
    } else {
      api.reload('743448d8', component.options)
    }
    module.hot.accept("./RemoteFolderConfigurationForm.vue?vue&type=template&id=743448d8&", function () {
      api.rerender('743448d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/RemoteFolder/RemoteFolderConfigurationForm.vue"
export default component.exports